import { useI18n, usePortfolioData } from "../i18n";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import PortfolioCard from "../components/common/portfolioCard";

const Experience = () => {
  const { user: INFO, seo: SEO, experiences: EXPERIENCES } = usePortfolioData();
  const { t } = useI18n();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const currentSEO = SEO.find((item) => item.page === "experience");

  const presentationExperiences = EXPERIENCES.filter(
    (experience) => experience.label === "presentation",
  );
  const blogExperiences = EXPERIENCES.filter(
    (experience) => experience.label === "blog",
  );

  const communityExperiences = EXPERIENCES.filter(
    (experience) => experience.label === "community",
  );

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${t("experience")} | ${INFO.main.title}`}</title>
        <meta name="description" content={currentSEO.description} />
        <meta name="keywords" content={currentSEO.keywords.join(", ")} />
      </Helmet>

      <div className="page-content">
        <NavBar active="experience" />
        <div className="content-wrapper">
          <div className="page-section">
            <div className="title">{INFO.experience.title}</div>

            <div className="subtitle">{INFO.experience.description}</div>

            <div className="collection">
              <div className="collection-groups">
                <div className="collection-label">{t("presentation")}</div>
                {presentationExperiences.map((experience) => (
                  <div className="collection-item" key={experience.id}>
                    <PortfolioCard item={experience} />
                  </div>
                ))}

                <div className="collection-label">{t("community")}</div>
                {communityExperiences.map((experience) => (
                  <div className="collection-item" key={experience.id}>
                    <PortfolioCard item={experience} />
                  </div>
                ))}

                <div className="collection-label">{t("blog")}</div>
                {blogExperiences.map((experience) => (
                  <div className="collection-item" key={experience.id}>
                    <PortfolioCard item={experience} />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="page-footer">
            <Footer />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Experience;
